import RootState from '../store.types';

export const profileSelector = ({ authentication: reducer }: RootState) => reducer.profile;
